import Alpine from "alpinejs";

function fallbackLink(url, error) {
    const defaultUrl = url.split(".ajax")[0];
    if (error) {
        [...document.querySelectorAll(`.-fetch-trigger[data-href="${defaultUrl}"]`)].forEach((element) => {
            element.remove();
        });
    }

    [...document.querySelectorAll(`.-fetch-fallback[href="${defaultUrl}"]`)].forEach((element) => {
        if (error) {
            element.classList.remove("hidden");
        } else {
            element.remove();
        }
    });
}

Alpine.data("fetch", (url) => ({
    init() {
        const isJumboMenu = url.includes("jumbo=1");
        fetch(url)
            .then((response) => {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.text();
            })
            .then((html) => {
                if (isJumboMenu) {
                    fallbackLink(url, !html);
                }
                if (html) {
                    this.$refs.target.innerHTML = html;
                } else {
                    this.$el.remove();
                }
            })
            .catch(() => {
                if (isJumboMenu) {
                    fallbackLink(url, true);
                }
                this.$el.remove();
            });
    },
}));
